import InstallAppAlert from './InstallAppAlert';

export default InstallAppAlert;
